import { render } from "./KeywordClustersVisualization.vue?vue&type=template&id=10618ef4&scoped=true"
import script from "./KeywordClustersVisualization.vue?vue&type=script&lang=js"
export * from "./KeywordClustersVisualization.vue?vue&type=script&lang=js"

import "./KeywordClustersVisualization.vue?vue&type=style&index=0&id=10618ef4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10618ef4"]])

export default __exports__